import styled from 'styled-components';

export const BottomBar = styled.div`
  text-align: right;

  & > button {
    min-width: 150px;
  }
`;
